import { render, staticRenderFns } from "./DeTabs.vue?vue&type=template&id=41e2e49f&scoped=true&"
import script from "./DeTabs.vue?vue&type=script&lang=js&"
export * from "./DeTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeTabs.vue?vue&type=style&index=0&id=41e2e49f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e2e49f",
  null
  
)

export default component.exports